import { Cancel, Circle, Description } from "@mui/icons-material";
import {
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import { DATA_SAVE_URL } from "../utils/UrlHandle";
import axios from "axios";

const NewRequests = ({
  anchorEl,
  handleClose,
  open,
  userNotification,
  setRefreshDashboard,
}) => {
  const handleCloseMessage = async (id) => {
    try {
      const response = await axios.put(
        DATA_SAVE_URL + "/api/v1/dashboard/" + id
      );
      setRefreshDashboard((pre) => (pre === true ? false : true));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Menu
      anchorEl={anchorEl}
      id="new-requests"
      open={open}
      onClose={handleClose}
      onClick={handleClose}
      slotProps={{
        paper: {
          elevation: 0,
          sx: {
            overflow: "auto",
            maxHeight: "80vh",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,

            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        },
      }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      {userNotification.map((data, index) => (
        <MenuItem onClick={handleClose} key={index}>
          <Box
            justifyContent="space-between"
            alignItems="center"
            display="flex"
            width="100%"
          >
            <Box display="flex" alignItems="center" width="100%">
              <ListItemIcon>
                <Description color="success" fontSize="large" />
              </ListItemIcon>
              <Box>
                <Typography variant="h5" fontWeight={600}>
                  {data.title}
                </Typography>
                <Typography variant="subtitle2">{data.message}</Typography>
                <Typography color="grey" variant="subtitle2">
                  {"Date : " + data.saveDate}
                </Typography>
              </Box>
            </Box>
            <Box display="flex">
              <Tooltip title="Mark as read">
                <span>
                  <IconButton aria-label="delete" disabled={data.viewed}>
                    <Circle
                      color={data.viewed ? "" : "info"}
                      fontSize="small"
                    />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title="Close message">
                <IconButton onClick={() => handleCloseMessage(data.id)}>
                  <Cancel color="error" fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default NewRequests;
